import { SWRConfiguration } from 'swr';

import { EntityAttribute } from '~/data/attributes/slice';
import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export const getEntityAttributes = async (
  entity: string,
): Promise<EntityAttribute[]> => {
  return fetchFromOldApi(`/json/customdata/entity/${entity}/attribute`).then(
    (r) => r.json(),
  );
};

type PropsType = {
  entity?: string;
};

/**
 * This is essentially SWR version of Redux based useEntityAttributes
 * Implemented as temporary alternative, due to type definition & data model discrepancy in useEntityAttributes output
 */
export const useGetEntityAttributes = (
  props: PropsType,
  swrConfig?: SWRConfiguration,
): UseArraySWROutput<EntityAttribute> => {
  const { entity } = props;

  const swrConfiguration: SWRConfiguration = {
    revalidateOnFocus: false,
    ...swrConfig,
  };

  return useArraySWR(
    !!entity ? ['useGetEntityAttributes', entity] : null,
    ([_key, entity]) => getEntityAttributes(entity),
    swrConfiguration,
  );
};
